import React, { useContext, useEffect, useState } from 'react';
import axios from 'axios';
import './styles/styles.scss';
import HomePage from './pages/home';
import { Route, Switch, HashRouter, Redirect, useLocation } from 'react-router-dom';
import StateSelectionPage from './pages/state-selection';
import ResultsPage from './pages/results';
import ProfilePage from './pages/profile';
import moment from 'moment';
import initializeApp from './lib/initialization';
import { AppContext } from './context/AppContext';
import { IAppContext } from './context/DefaultAppState';
// import { config } from 'dotenv';
import DownloadPage from './pages/download';
import { distanceOptions } from './lib/util';
import * as _ from 'lodash';
import { IPlan } from './interfaces/IPlan';

// config({
//   path: `.env.${process.env.NODE_ENV}`
// });

axios.defaults.baseURL = process.env.REACT_APP_API_BASE_URL;

const App = (props: any) => {
  const appContext = useContext(AppContext);
  const plansWithUniqueHcode: IPlan[] = _.uniqBy(appContext.plansData, 'contractId');
  useEffect(() => {
    initialize(appContext);
  }, []);

  const { hash } = useLocation();
  //const hashUrl = hash.split('?')[1];
  //const hashParams = new URLSearchParams(hashUrl);
  //const distance = hashParams.get('distance');
  
  return (
    <>
      <HashRouter>
        <Switch>
          {(appContext.plan && appContext.planState) || hash.includes('/profile') ? <Route path="/profile/:planCode/:recordId/:directory" component={ProfilePage} /> : null}
          {(appContext.plan && appContext.planState) || hash.includes('/results') ? <Route path="/results/:planCode?/:directory?/:specialty?/:name?/:location?" component={ResultsPage} /> : null}
          <Route path="/state-selection" component={StateSelectionPage} />
          <Route path="/download/:planCode" exact component={DownloadPage} />
          <Route path="/" exact component={HomePage} />
        </Switch>
      </HashRouter>
      <div className="footer-container">
        <div>CMS ID Number: 
		  {plansWithUniqueHcode.map((planData, i, arr) => (<span> {planData.contractId}{i != (arr.length-1) &&  (arr.length-1 != 0)? ', ' : ''}</span>))}
		</div>
        <div>Directory Data Updated: {moment(appContext.cacheTime).format('MM/DD/YYYY')}</div>
      </div>
    </>
  );
};

const initialize = (appContext: IAppContext) => {
  (async () => {
    await initializeApp(appContext);
  })();
};

export default App;
